import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ContractsService, EventsService, Filter, FilterContracts, FilterEvents, HttpService } from "../../services";
import { Agent, Contract, Event, EventFilterDate, EventTypes, Product, StatusContract } from "../../models";
import { ActivatedRoute, Params } from "@angular/router";
import { PagerService } from "../../services/index";
import { TreeUtil } from "../../util/tree";
import { AgentUtility } from "../../util/agent.utility";
import { AppSettings } from '../../app.settings';
import { StringUtility } from "../../util/string.utility";
import { noUndefined } from "@angular/compiler/src/util";
import { AgentsService } from "../../services/agents.service";
import { MeetingsService } from "../../services/meetings.service";

@Component({
    moduleId: module.id,
    selector: 'calendar',
    templateUrl: 'calendar.events.component.html',
    styles: ['a { cursor: pointer; }'],
    providers: [EventsService, ContractsService, AgentsService, PagerService]
})
export class CalendarEventsComponent implements OnInit, OnDestroy {
    @ViewChild('filter_tree',{static: false}) container;
    activenodes: any[] = [];
    showfilter: boolean = false;
    showoverlay: boolean = false;
    isMobile: boolean = window.innerWidth <= 1200;

    get ActiveNodes() {
        function sortNodes(firstNode, secondNode) {
            return firstNode.index - secondNode.index
        }

        if (this.activenodes.length > 1)
            this.activenodes.sort(sortNodes);

        return this.activenodes.map(x => x.data.Name).join(', ');
    }

    nodes: any[] = [];
    _agent: Agent = new Agent;
    eventFilterDate = EventFilterDate;
    contracts: Contract[] = [];
    events: Event[] = [];
    meetings: any[] = [];
    complexEvents:any[];
    complexEventsAll:any[];
    types: EventTypes[] = [];
    products: Product[] = [];
    statuses: StatusContract[] = [];
    otherAgent: boolean;
    agentId: number;
    date: Date = new Date;
    showStartDate: boolean = false;
    datepickerOpts: any = {
        autoclose: true,
        todayHighlight: true,
        assumeNearbyYear: true,
        format: 'dd.mm.yyyy',
        placeholder: " ",
        icon: 'client-full__calendar',
        language: 'ru'
    };
    sub: any;
    showAll: boolean = false;
    filterContracts: FilterContracts = new FilterContracts();
    filterEvents: FilterEvents = new FilterEvents();
    pagerProducts: any = {};
    pagerEvents: any = {};
    pageSize: number = 10;
    totalItemsProducts: number;
    totalItemsEvents: number;
    totalItemsMeetings:number;
    totalItemsAll: number;
    showLoadScreen: boolean = false;
    treeAgents: any[] = [];

    constructor(private activatedRoute: ActivatedRoute,
        private eventsService: EventsService,
        private contractService: ContractsService,
        private agentService: AgentsService,
        private pagerService: PagerService,
        private meetingsService:MeetingsService,
        private eRef: ElementRef) {
        this.eventsService.onStart = () => this.showLoadScreen = true;
        this.eventsService.onEnd = () => this.showLoadScreen = false;

    }

    get TotalComplexEvents():number{
        let count = this.totalItemsEvents;
        if([undefined,"6","-1000"].includes(this.filterEvents.EventType))
            count += this.totalItemsMeetings;
        return count;
    }

    InitializeComplexEvents(){
        let preparedEvents:any[] = this.events.map(e => {
            return {date:e.EventDate, type:"Event", data:e}
        })
        let preparedMeetings:any[] = this.meetings.map(m => {
            return {date:m.Date, type:"Meeting", data:m}
        })
        this.complexEventsAll =  preparedEvents.concat(preparedMeetings).sort((ce1,ce2) => {
            return (new Date(ce1.date).getTime() - new Date(ce2.date).getTime());
        });
        this.totalItemsAll = this.totalItemsEvents + this.totalItemsMeetings;
        this.complexEvents = this.complexEventsAll.slice(0, 10);
    }

    eventHandlerEvents(event) {
        if (event.key == "Enter"){
            this.getMeetings();
            this.getEvents();
        }
    }

    
    getMeetingColor(result:string, DocumentsStatusName:string):string{
        let color = ""

        if(DocumentsStatusName === 'Подтвержден'){
            color = "#48ab17";
        }
        else{
            switch(result){
                case "Продажа":
                    color = "#ff1e00";
                break
                case "В обработке":
                    color = "#ff1e00";
                break
                case "Отказ":
                    color = "#F5B81A";
                break
                case "Назначение повторной встречи":
                    color = "#48ab17";
                break
                default:
                    color = "#48ab17"
                break
            }
        }
        return color;
    }

        
    getMeetingImage(result:string, DocumentsStatusName:string):string{
        let image = ""
        if(DocumentsStatusName === 'Подтвержден'){
            image = "../../assets/img/success_doc_icon.png";
        }
        else{
            switch(result){
                case "Продажа":
                    image = "../../assets/img/icon-doc-fail.png";
                break
                case "В обработке":
                    image = "../../assets/img/icon-doc-fail.png";
                break
                case "Отказ":
                    image = "../../assets/img/icon-doc-fail.png";
                break
                case "Назначение повторной встречи":
                    image = "../../assets/img/icon-doc-fail.png";
                break
                default:
                    image = "../../assets/img/success_doc_icon.png"
                break
            }
        }
        return image;
    }

    getPhone(phone:string):string{
        if(!phone)
          return "";
        if(phone == "")
          return "";
        let type:string = phone.length < 3? "SHORT" : phone.length == 3? "MIDDLE" : "LONG";
        let result:string;
        switch(type){
          case "SHORT":
            result = `+7 (${phone.slice(0,phone.length)}`;
            break;
          case "MIDDLE":
            result = `+7 (${phone.slice(0,3)})`;
            break;
          case "LONG":
            let middleCode = phone.slice(3,6);
            let endCode = phone.length >= 6? phone.slice(6) : "";
            result = endCode == "" ? `+7 (${phone.slice(0,3)}) ${middleCode}` : `+7 (${phone.slice(0,3)}) ${middleCode} ${endCode}`;
            break;
        }
        return result;
      }

    splited(phone) {
        if (phone != null && phone != "")
            return phone.split(',');
    }

    seeEvent(event) {
        let changeObj = {};
        if (event.IsViewed) {
            changeObj = {
                Id: event.Id,
                IsViewed: !event.IsViewed,
                ViewedByAgentId: null
            }
        } else {
            changeObj = {
                Id: event.Id,
                IsViewed: !event.IsViewed,
                ViewedByAgentId: this.getUser().Id
            }
        }
        this.eventsService.changeEvent(changeObj).subscribe((data) => {
            event = Object.assign(event, data.data);
        });
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        if (event.target.innerWidth <= 1200) {
            this.isMobile = true;
        } else {
            this.isMobile = false;
        }
    }


    setPageAll(page: number, needRequest: boolean = false) {
        if (page < 1)
            return;
        this.pagerEvents = this.pagerService.getPager(this.totalItemsAll, page, this.pageSize);
        if (window.innerWidth <= 1200)
            this.pagerEvents = this.pagerService.getPagerMobile(this.totalItemsAll, page, this.pageSize);
        if (page > this.pagerEvents.totalPages) {
            return;
        }
        if (needRequest) {
            //this.filterEvents.page = page;
            //this.filterEvents.limit = 10;
            let start = (10 * page) - 10;
            let end = start + 10;
            this.complexEvents = this.complexEventsAll.slice(start, end);
        }
    }

    setPageEvents(page: number, needRequest: boolean = false) {
        if (page < 1)
            return;
        this.pagerEvents = this.pagerService.getPager(this.totalItemsEvents, page, this.pageSize);
        if (window.innerWidth <= 1200)
            this.pagerEvents = this.pagerService.getPagerMobile(this.totalItemsEvents, page, this.pageSize);
        if (page > this.pagerEvents.totalPages) {
            return;
        }
        if (needRequest) {
            this.filterEvents.page = page;
            this.filterEvents.limit = 10;
            this.eventsService.getEvents(this.filterEvents).subscribe((data) => {
                this.events = data.data;
                this.totalItemsEvents = data.countAll;
                this.InitializeComplexEvents();
            });
        }
    }

    setPageMeetings(page: number, needRequest: boolean = false) {
        if (page < 1)
            return;
        this.pagerEvents = this.pagerService.getPager(this.totalItemsMeetings, page, this.pageSize);
        if (window.innerWidth <= 1200)
            this.pagerEvents = this.pagerService.getPagerMobile(this.totalItemsMeetings, page, this.pageSize);
        if (page > this.pagerEvents.totalPages) {
            return;
        }
        if (needRequest) {
            this.filterEvents.page = page;
            this.filterEvents.limit = 10;
            if(this.filterEvents.agents){
                if(this.filterEvents.agents[0] != undefined){
                    this.agentService.getAgent(this.filterEvents.agents[0]).subscribe(data => {
                        let dataAgent = data.data;
                        this.filterEvents.ContactId = dataAgent.ContactId;
                    });
                }
            }
            this.meetingsService.getMeetingsByFilter(this.filterEvents).subscribe(data => {
                this.meetings = data.data;
                this.totalItemsMeetings = data.countAll;
            });
        }
    }

    getExcel(e, type): any {
        e.preventDefault;
        let filter: any = {};
        if (type == 'contracts')
            filter = this.filterContracts;
        else
            filter = this.filterEvents;
        filter.excel = true;
        filter.limit = "all";
        return this.eventsService.getFile(filter, type).subscribe((data) => {
            document.location.href = data.path;
            this.filterEvents.excel = false;

        }
        );
    }

    getUser(): any {
        return AgentUtility.getUser();
    }

    checkEmpty(): boolean {
        if (this.filterContracts.StartDate == null)
            return false;
        else if (this.filterContracts.EndDate == null)
            return false;
    }

    getEvents(): any {
        if(["6"].includes(this.filterEvents.EventType)){
            this.events = [];
            this.totalItemsEvents = 0;
            return;
        }
        //this.filterEvents.page = 1;
        this.filterEvents.deep = true;
        let agentId = AgentUtility.getUser();
        this.filterEvents.AgentId = agentId.Id;
        this.eventsService.getEvents(this.filterEvents).subscribe((data) => {
            this.events = data.data;
            this.totalItemsEvents = data.countAll;
            //this.setPageEvents(1, false);
            this.InitializeComplexEvents()
            this.setPageAll(1, false);
        });
    }

    private bindPersonLinks(){
        this.meetings.forEach((m,i) => {
            this.meetingsService.getClientInfo(m.Id).subscribe(data => {
                m.Person = data.data.length == 1? data.data[0] : null;
                if(i+1 == this.meetings.length)
                    this.InitializeComplexEvents();
            })
        })
    }


    private filterDate(){
        if(this.filterEvents.typeDate == 0){
            var seventhDay = new Date();
            seventhDay.setDate(seventhDay.getDate());
            this.meetings = this.meetings.filter((meeting) => {
                return new Date(meeting.Date).getDate() == seventhDay.getDate() && new Date(meeting.Date).getMonth() + 1 == seventhDay.getMonth() + 1
            })
            this.totalItemsMeetings = this.meetings.length;
        }
        if(this.filterEvents.typeDate == 1){ //
            var seventhDay = new Date();
            var seventhDay2 = new Date();
            seventhDay.setDate(seventhDay.getDate() + 7);
            seventhDay2.setDate(seventhDay2.getDate() - 1);
            
            this.meetings = this.meetings.filter((meeting) => {
                return new Date(meeting.Date).getTime() <= seventhDay.getTime() && new Date(meeting.Date).getTime() >= seventhDay2.getTime()
            })
            this.totalItemsMeetings = this.meetings.length;
        }
        // if(this.filterEvents.typeDate == 2){
        //     var seventhDay = new Date();
        //     this.meetings = this.meetings.filter((meeting) => {
        //         return new Date(meeting.Date).getMonth() + 1 == seventhDay.getMonth() + 1
        //     })
        //     this.totalItemsMeetings = this.meetings.length;
        // }
    }

    getMeetings(){
        let agentId = AgentUtility.getUser();
        this.filterEvents.AgentId = agentId.Id;
        //this.filterEvents.page = 1;
        this.filterEvents.deep = true;
        //let dataAgent = this.filterEvents.agents;
        //this.filterEvents.ContractId = dataAgent.;
        if([undefined,"6","-1000"].includes(this.filterEvents.EventType)){
            if(this.filterEvents.agents){
                if(this.filterEvents.agents[0] != undefined){
                    let count = this.filterEvents.agents.length;
                    let countRequest = 0;
                    this.filterEvents.agentsContract = [];
                    for(let item of this.filterEvents.agents){
                        this.agentService.getAgent(item).subscribe(data => {
                            let dataAgent = data.data;
                            this.filterEvents.agentsContract.push(dataAgent.ContactId);
                            countRequest += 1;

                            if(count == countRequest){
                                this.meetingsService.getMeetingsByFilterMeetings(this.filterEvents).subscribe(data => {
                                    this.meetings = data.data[0];
                                    this.totalItemsMeetings = data.data[1].rowCount;
                                    if(this.filterEvents.Number){
                                        let fio = this.filterEvents.Number.split(' ');
                                        let LastName = null;
                                        let FirstName = null;
                                        let MiddleName = null;
                                        if(fio[0]) { //Фамилия
                                            LastName = fio[0];
                                        }
                                        if(fio[1]) { //Имя
                                            FirstName = fio[1];
                                        }
                                        if(fio[2]) { //Отчество
                                            MiddleName = fio[2];
                                        }
                                        this.meetings = this.meetings.filter(item => {
                                            if(LastName != null && FirstName != null && MiddleName != null){
                                                return item.LastName == LastName && item.FirstName == FirstName && item.MiddleName == MiddleName
                                            }
                                            else if (LastName != null && FirstName != null){
                                                return item.LastName == LastName && item.FirstName == FirstName
                                            }
                                            else if (LastName != null){
                                                return item.LastName == LastName
                                            }
                                        });
                                    }
                                    this.filterDate()
                                    this.InitializeComplexEvents()
                                    this.setPageAll(1, false);
                                });
                            }
                        });
                    }
                }
                else{
                    this.agentService.getAgent(agentId.Id).subscribe(data => {
                        let dataAgent = data.data;
                        this.filterEvents.AgentId = dataAgent.ContactId;
                    
                        if(this.filterEvents.Number != undefined){
                            this.meetingsService.getMeetingsByFilterLinkMeetings(this.filterEvents).subscribe(data => {
                                this.meetings = data.data[0];
                                this.totalItemsMeetings = data.countAll;
                                this.filterDate();
                                this.InitializeComplexEvents()
                                this.setPageAll(1, false);
                                
                            });
                        }
                        else{
                            this.meetingsService.getMeetingsByFilterLink(this.filterEvents).subscribe(data => {
                                this.meetings = data.data[0];
                                this.totalItemsMeetings = data.data[1].rowCount;
                                this.filterDate();
                                this.InitializeComplexEvents()
                                this.setPageAll(1, false);
                                
                            });
                        }
                    });
                }
            }
            else{
                this.agentService.getAgent(agentId.Id).subscribe(data => {
                    let dataAgent = data.data;
                    this.filterEvents.AgentId = dataAgent.ContactId;
                
                    if(this.filterEvents.Number != undefined){
                        this.meetingsService.getMeetingsByFilterLinkMeetings(this.filterEvents).subscribe(data => {
                            this.meetings = data.data[0];
                            this.totalItemsMeetings = data.countAll;
                            this.filterDate();
                            this.InitializeComplexEvents()
                            this.setPageAll(1, false);
                            
                        });
                    }
                    else{
                        this.meetingsService.getMeetingsByFilterLink(this.filterEvents).subscribe(data => {
                            this.meetings = data.data[0];
                            this.totalItemsMeetings = data.data[1].rowCount;
                            this.filterDate();
                            this.InitializeComplexEvents()
                            this.setPageAll(1, false);
                            
                        });
                    }
                });
            }

            
        }
        else{
            this.meetings = [];
            this.InitializeComplexEvents();
        }
    }

    eventRowPink(complexEvents) {
        var currentDate = new Date();
        if(complexEvents.type != "Event")
            return "client-full__item";
        let event = complexEvents.data;
        return (event.EventTypeId == 2 && new Date(event.EventDate).getTime() < currentDate.getTime()) && !(event.Amount != null && (event.DocumentStatusId == 6 || event.DocumentStatusId == 463)) ? "client-full__item_pink" : "client-full__item";
    }

    active(node) {
        //node.toggleExpanded();
        // if (node.data.Id == this.getUser().Id)
        //     return false;

        // TreeUtil.setActiveWithChildrens(node);
        node.data.isChoose = !node.data.isChoose;
        this.expandAndActivate(node);
        this.getEvents();
        this.getMeetings();
        // this.getContracts();
    }

    expandAndActivate(node) {
        if (node.data.isChoose && !node.isExpanded)
            node.toggleExpanded();
        if (!node.data.isChoose && node.isExpanded)
            node.collapse();
        this.searchForAgents(node);
        node.IsClickedBefore = true;
        //node.onToggleExpanded();
        if (node.children && node.children.length > 0) {
            for (let i = 0; i < node.data.children.length; i++) {

                if (!(node.children[i].IsClickedBefore)) {
                    node.children[i].data.isChoose = node.data.isChoose;
                    this.expandAndActivate(node.children[i]);
                }
                else node.children[i].IsClickedBefore = false;

                if (node.children[i].data.isChoose == node.data.isChoose)
                    continue;
                node.children[i].data.isChoose = node.data.isChoose;
                if (node.children[i].data.isChoose == false)
                    this.searchForAgents(node.children[i], false);
                else
                    this.searchForAgents(node.children[i]);
            }
        } else {
            node.children = [];
        }
    }

    searchForAgents(node, choosen = true) {
        let currentUser = AgentUtility.getUser();
        let index = this.activenodes.findIndex(x => x.id == node.id);
        if (index == -1 && !choosen)
            return;
        if (index >= 0) {
            this.activenodes.splice(index, 1);
            let indexContracts = this.filterContracts.agents.indexOf(node.data.Id);
            if (indexContracts != -1)
                this.filterContracts.agents.splice(indexContracts, 1);
            let indexEvents = this.filterEvents.agents.indexOf(node.data.Id);
            if (indexEvents != -1)
                this.filterEvents.agents.splice(indexEvents, 1);
        } else {
            if (currentUser.Id != node.data.Id) {
                this.activenodes.push(node);

                if (this.filterContracts.agents == undefined)
                    this.filterContracts.agents = [];
                this.filterContracts.agents.push(node.data.Id);

                if (this.filterEvents.agents == undefined)
                    this.filterEvents.agents = [];
                this.filterEvents.agents.push(node.data.Id);
            }
        }
    }

    onEvent2(event) {
        //
    }

    eventClickEvents(Id) {
        this.filterEvents.EventTypeId = Id;
        this.getEvents();
        this.getMeetings();
    }


    getProducts(): any {
        this.contractService.getProductList().subscribe((data) => {
            this.products = data.data;
        }
        );
    }

    getTypesEvents(): any {
        this.eventsService.getTypesList().subscribe((data) => {
            this.types = data.data;
        }
        );
    }

    getStatuses(): any {
        this.contractService.getStatusesList().subscribe((data) => {
            this.statuses = data.data;
        }
        );
    }

    getOtherUser(): any {
        if (this._agent != null)
            return this._agent;
        return new Agent;
    }

    onEvent = function (event) {
        if (event.node.children.length > 0)
            return false;
        //let contractLeaderId = event.node.data.ContractLeaderId;
        //let currcontractId = event.node.data.ContractId;

        let currNode = TreeUtil.getSubMenuItem(this.nodes, event.node.id);
        let myContractId = this.getUser().Id;
        let myContractLeaderId = this.getUser().ContractLeaderId;
        // если нажимаем на себя, возвращаем всех подчиненных
        if (currNode.Id == myContractId) {
            this.toggleSubordinates(currNode);
            return;
        }
        this.eventsService.getAgentsTreeByClientLeaderId(myContractLeaderId).subscribe(data => {
            let agents = data;

            this.eventsService.getAgent(this.getUser().Id).subscribe((data) => {
                agents.push(data);
                if (agents) {
                    for (let i = 0; i < agents.length; i++) {
                        if (currNode.Id == agents[i].Id) {
                            let childAgent = agents.filter((agent) => {
                                return agent.ContractLeaderId == agents[i].Id;
                            });

                            if (childAgent[0].Id == myContractLeaderId) {
                                //this.toggleSubordinates(currNode, myContractLeaderId);

                            }

                            childAgent[0].hasChildren = true;
                            childAgent[0].children = [];
                            childAgent[0].isParent = true;
                            currNode.children = childAgent;
                            this.nodes = [...this.nodes, {}];
                            this.nodes.splice(-1, 1);

                            return false;
                        }
                    }
                    this.toggleSubordinates(currNode, undefined);
                }
            });

        });
        return;
    };

    toggleSubordinates(currNode, contractLeaderId) {
        let filter = new Filter();
        filter.ContractLeaderId = contractLeaderId != undefined ? contractLeaderId : currNode.Id;
        filter.limit = "all";
        let agents = this.agentService.getAgentsByFilter(filter).subscribe((data) => {
            if (data.data !== undefined && data.data.length > 0) {
                for (let i = 0; i < data.data.length; i++) {
                    data.data[i].hasChildren = true;
                    data.data[i].children = [];
                    data.data[i].isParent = true;
                }
                currNode.children = data.data;
            } else {
                currNode.children = [];
                currNode.hasChildren = false;
                currNode.isParent = false;
            }

            // Фикс рефреша дерева
            this.nodes = [...this.nodes, {}];
            this.nodes.splice(-1, 1);
        });
    }

    ngOnInit() {
        this.filterEvents.typeDate = this.eventFilterDate.Weekly;
        // Грузим дерево агентов для фильтра
        let Id = AgentUtility.getUser().Id;
        this.agentService.getAgentTreeByFilter(Id, { downOnly: true }).subscribe(res => {
            let data = res.data;
            data[0].isParent = true;
            this.nodes = data;
            //
        });

        // TODO: привести фильтр к единой модели, убрать проверки.
        let filterContracts = JSON.parse(localStorage.getItem('filterContracts'));
        if (filterContracts) {

            if (filterContracts.eventTypeId)
                this.filterEvents.EventTypeId = filterContracts.eventTypeId;
            if (filterContracts.PersonId)
                this.filterEvents.PersonId = +filterContracts.PersonId;

            localStorage.setItem('filterContracts', null);
        } else {
            this.filterEvents.EventTypeId = -1000;
        }

        this.getEvents();
        this.getMeetings();
        // this.getContracts();
        // this.getProducts();
        this.getStatuses();
        this.getTypesEvents();
        this.filterContracts.ProductId = -1;
        this.filterContracts.StatusId = 0;


        //this.toggleLoadScreen();
        // let agentId = this.getUser().Id;
        // this.httpService.getAgentTree(agentId)
        //     .then(res => {
        //         this.treeAgents = res.json().data;
        //         this.toggleLoadScreen();
        //     });
    }

    ngOnDestroy() {
         //this.sub.unsubscribe();
    }


    @HostListener('document:click', ['$event'])
    clickout(event) {
        if (this.eRef.nativeElement.contains(event.target)) {

        } else {
            if (event.srcElement.pathname == '/events') {
                this.filterEvents = new FilterEvents();
                this.getEvents();
                this.getMeetings();
            }

        }
    }

    filterPhoneView(str) {
        return StringUtility.PhoneMask(str);
    }

    public getPaymentUrl(contract): string {
        return `portfolio/${contract.ContractHeaderId}`;
    }
}